import { useProductCardMetadata } from '../../merch-card/cards/product-card/useProductCard';
import CurrentPlanTag from './CurrentPlanTag';

/**
 * @description
 * This component is responsible for rendering only one badge at a time as we don't want to show multiple badges at once. This is similar to our BannerHierarchy component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductCardBadge = ({
  apiName
}) => {
  const {
    isCurrentPlanLevel
  } = useProductCardMetadata({
    apiName
  });
  return isCurrentPlanLevel ? /*#__PURE__*/_jsx(CurrentPlanTag, {}) : null;
};